// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setting_container {
  width: 100%;
  height: 100vh;
  padding: 0 2rem;
  position: absolute;
  top: 0;
  background-color: #151018;
  z-index: 2;
  overflow-x: hidden;
  overflow-y: auto;
}
.setting_container .setting_header {
  width: 100%;
  padding: 2rem 1.5rem 0.2rem 1.5rem;
  display: flex;
}
.setting_container .setting_header .setting_logo {
  width: 15%;
  display: flex;
  align-items: center;
  position: relative;
}
.setting_container .setting_header .setting_logo img {
  width: 30%;
  margin-left: 30%;
}
.setting_container .setting_header .setting_logo .back {
  position: absolute;
  right: 0.4rem;
  top: 50%;
  transform: translateY(-50%);
  width: 46.34px;
  height: 46.34px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  color: #FFFFFF;
  background-color: #231B27;
  border: 1px solid #231B27;
  border-radius: 0.4rem;
}
.setting_container .setting_header .setting_logo .back:hover {
  background-color: #2a202e;
  color: rgb(214, 65, 10);
}
.setting_container .setting_header .setting_search {
  width: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.setting_container .setting_header .setting_search .input {
  width: 100%;
  height: 46.34px;
  padding: 0.48rem 1rem;
  outline: none;
  background-color: #231B27;
  border-radius: 0.6rem;
  border: 1px solid #231B27;
  color: #898989;
  font-size: 1.2rem;
}
.setting_container .setting_header .setting_search .input::placeholder {
  color: #898989;
}
.setting_container .setting_header .setting_avatar {
  width: 15%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}
.setting_container .setting_header .setting_avatar .avatar {
  width: 3.313rem;
  height: 3.313rem;
  background-color: #bababa;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.3rem;
  font-weight: 700;
  cursor: pointer;
  transition: 0.1s linear;
}
.setting_container .setting_header .setting_avatar .avatar:hover {
  background-color: #e8e5e5;
  color: rgb(214, 65, 10);
  font-size: 1.5rem;
}
.setting_container .setting_header .setting_avatar .sub_list {
  width: 80%;
  margin: 0 auto;
  padding: 0.5rem 0.2rem;
  background-color: #231B27;
  position: absolute;
  bottom: -3.5rem;
  border-radius: 0.6rem;
  z-index: 10;
}
.setting_container .setting_header .setting_avatar .sub_list .item {
  display: block;
  margin: 0.4rem 1rem;
  text-decoration: none;
  color: #FFFFFF;
}
.setting_container .setting_header .setting_avatar .sub_list .item:hover {
  color: rgb(214, 65, 10);
}
.setting_container .setting_content {
  width: 70%;
  margin: 0 auto;
  padding: 0 1rem;
}
.setting_container .setting_content h2 {
  color: #FFFFFF;
  margin: 1rem 0;
  font-size: 2rem;
}
.setting_container .setting_content .setting_settings {
  width: 55rem;
  min-height: 36rem;
  background-color: #231B27;
  padding: 1rem 2rem;
  margin-bottom: 2rem;
  border-radius: 0.8rem;
  font-size: 80%;
}
.setting_container .setting_content .setting_settings .options {
  display: flex;
  font-size: 1rem;
  font-weight: 500;
  gap: 3rem;
  margin-top: 1rem;
}
.setting_container .setting_content .setting_settings .options li {
  list-style: none;
  color: #e8e5e5;
  border-bottom: 1px solid #e8e5e5;
  cursor: pointer;
}
.setting_container .setting_content .setting_settings .setting_details_content {
  width: 100%;
  padding: 1rem 0.5rem;
  margin-top: 2rem;
}
.setting_container .setting_content .setting_settings .setting_details_content .input_block {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 1.5rem 0;
}
.setting_container .setting_content .setting_settings .setting_details_content .input_block label {
  font-weight: 400;
  font-size: 1rem;
  color: #FFFFFF;
}
.setting_container .setting_content .setting_settings .setting_details_content .input_block .validate_all_doc {
  width: 12.9rem;
  background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);
  color: #FFFFFF;
  font-weight: 600;
  font-size: 0.9rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0.6rem 1rem;
  outline: none;
  border: 1px solid transparent;
  border-radius: 0.3rem;
  cursor: pointer;
  transition: 0.2s linear;
}
.setting_container .setting_content .setting_settings .setting_details_content .input_block .validate_all_doc:hover {
  background: linear-gradient(180deg, #D91D6F 50%, #92124A 100%);
  border: 1px solid #FFFFFF;
}
.setting_container .setting_content .setting_settings .setting_details_content .input_block .img {
  width: 12%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.setting_container .setting_content .setting_settings .setting_details_content .input_block .creating {
  display: flex;
  animation: detecting 0.8s linear infinite;
}
.setting_container .setting_content .setting_settings .setting_details_content .input_block select {
  width: 60%;
  height: 3rem;
  outline: none;
  padding-left: 0.5rem;
  background-color: #231B27;
  border: 0.12rem solid #FFFFFF;
  border-radius: 0.3rem;
  color: #FFFFFF;
  font-weight: 600;
}
.setting_container .setting_content .setting_settings .setting_details_group {
  width: 100%;
  margin-top: 2rem;
  display: flex;
}
.setting_container .setting_content .setting_settings .setting_details_group .mumbers {
  width: 100%;
  position: relative;
  padding: 1.5rem 0.5rem;
}
.setting_container .setting_content .setting_settings .setting_details_group .mumbers .mumber_avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: capitalize;
  font-size: 1.1rem;
  font-weight: 700;
  width: 3rem;
  height: 3rem;
  background-color: #bababa;
  border-radius: 50%;
  position: absolute;
  top: 0;
  -webkit-user-select: none;
          user-select: none;
  border: 1px solid rgb(255, 255, 255);
}
.setting_container .setting_content .setting_settings .setting_details_group .mumbers .mumber_avatar:hover {
  background-color: #e8e5e5;
}
.setting_container .setting_content .setting_settings .setting_details_police {
  width: 100%;
  padding: 0.5rem 0.5rem;
  margin-top: 0.5rem;
  display: flex;
}
.setting_container .setting_content .setting_settings .setting_details_police .police_left {
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.setting_container .setting_content .setting_settings .setting_details_police .police_left .police_block {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}
.setting_container .setting_content .setting_settings .setting_details_police .police_left .police_block label {
  font-weight: 400;
  font-size: 0.8rem;
  color: #FFFFFF;
}
.setting_container .setting_content .setting_settings .setting_details_police .police_left .police_block select,
.setting_container .setting_content .setting_settings .setting_details_police .police_left .police_block input {
  width: 80%;
  height: 2rem;
  outline: none;
  padding-left: 0.5rem;
  background-color: #231B27;
  border: 0.12rem solid #FFFFFF;
  border-radius: 0.3rem;
  color: #FFFFFF;
  font-weight: 600;
}
.setting_container .setting_content .setting_settings .setting_details_police .police_left .police_block input[type=range] {
  width: 80%;
  height: 6px;
  margin: 0.4rem 0;
  background: #dddddd;
  border-radius: 5px;
  outline: none;
  appearance: none;
}
.setting_container .setting_content .setting_settings .setting_details_police .police_left .police_block input[type=range]::-webkit-slider-thumb {
  appearance: none;
  width: 6px;
  height: 20px;
  background: #898989;
  border-radius: 1rem;
  cursor: pointer;
}
.setting_container .setting_content .setting_settings .setting_details_police .police_left .police_block .show_hide_stroke {
  width: 80%;
  display: flex;
  align-items: center;
  font-size: 1.8rem;
  border: 1px solid red;
}
.setting_container .setting_content .setting_settings .setting_details_police .police_left .police_block_eye {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.2rem;
}
.setting_container .setting_content .setting_settings .setting_details_police .police_left .police_block_eye label {
  font-weight: 400;
  font-size: 0.8rem;
  color: #FFFFFF;
}
.setting_container .setting_content .setting_settings .setting_details_police .police_left .police_block_eye .show_hide_stroke {
  width: -moz-fit-content;
  width: fit-content;
  display: flex;
  align-items: center;
  font-size: 1.8rem;
}
.setting_container .setting_content .setting_settings .setting_details_police .police_right {
  width: 50%;
  height: 20rem;
  position: relative;
}
.setting_container .setting_content .setting_settings .setting_details_police .police_right svg {
  width: 30rem;
  background-color: #c5c5c5;
}
.setting_container .setting_content .setting_settings .setting_details_police .police_right .valid_btn {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  position: absolute;
  bottom: -10rem;
}
.setting_container .setting_content .setting_settings .setting_details_police .police_right .valid_btn button {
  width: 8rem;
  height: 2.5rem;
  font-size: 1rem;
  font-weight: 600;
  background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);
  color: rgba(255, 255, 255, 0.6980392157);
  outline: none;
  border: 1px solid rgba(255, 255, 255, 0.1490196078);
  border-radius: 0.2rem;
  cursor: pointer;
  transition: 0.2s linear;
}
.setting_container .setting_content .setting_settings .setting_details_police .police_right .valid_btn button:hover {
  background: linear-gradient(180deg, #D91D6F 100%, #92124A 0%);
}

@keyframes detecting {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/settings/_Settings.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;AACJ;AACI;EACI,WAAA;EACA,kCAAA;EACA,aAAA;AACR;AACQ;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AACZ;AACY;EACI,UAAA;EACA,gBAAA;AAChB;AAEY;EACI,kBAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;AAAhB;AAEgB;EACI,yBAAA;EACA,uBAAA;AAApB;AAKQ;EACI,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAHZ;AAKY;EACI,WAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;AAHhB;AAKgB;EACI,cAAA;AAHpB;AAQQ;EACI,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AANZ;AAQY;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AANhB;AAQgB;EACI,yBAAA;EACA,uBAAA;EACA,iBAAA;AANpB;AAUY;EACI,UAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EAEA,qBAAA;EACA,WAAA;AAThB;AAWgB;EACI,cAAA;EAEA,mBAAA;EACA,qBAAA;EACA,cAAA;AAVpB;AAYoB;EACI,uBAAA;AAVxB;AAiBI;EACI,UAAA;EACA,cAAA;EACA,eAAA;AAfR;AAiBQ;EACI,cAAA;EACA,cAAA;EACA,eAAA;AAfZ;AAkBQ;EACI,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;AAhBZ;AAkBY;EACI,aAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;AAhBhB;AAkBgB;EACI,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,eAAA;AAhBpB;AAqBgB;EACI,WAAA;EACA,oBAAA;EACA,gBAAA;AAnBpB;AAqBoB;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AAnBxB;AAqBwB;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AAnB5B;AAsBwB;EACI,cAAA;EACA,6DAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,6BAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;AApB5B;AAsB4B;EACI,8DAAA;EACA,yBAAA;AApBhC;AAwBwB;EACI,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAtB5B;AAyBwB;EACI,aAAA;EACA,yCAAA;AAvB5B;AA0BwB;EACI,UAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,yBAAA;EACA,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AAxB5B;AA8BgB;EACI,WAAA;EACA,gBAAA;EACA,aAAA;AA5BpB;AA+BoB;EACI,WAAA;EACA,kBAAA;EACA,sBAAA;AA7BxB;AA+BwB;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oCAAA;AA7B5B;AA+B4B;EACI,yBAAA;AA7BhC;AAmCgB;EACI,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;AAjCpB;AAoCoB;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAlCxB;AAqCwB;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AAnC5B;AAqC4B;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;AAnChC;AAsC4B;;EAEI,UAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,yBAAA;EACA,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AApChC;AAuC4B;EACI,UAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EAEA,gBAAA;AArChC;AAuCgC;EAEI,gBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AArCpC;AAyC4B;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;AAvChC;AA2CwB;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AAzC5B;AA2C4B;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;AAzChC;AA4C4B;EACI,uBAAA;EAAA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AA1ChC;AAgDoB;EACI,UAAA;EACA,aAAA;EACA,kBAAA;AA9CxB;AAiDwB;EACI,YAAA;EACA,yBAAA;AA/C5B;AAmDwB;EACI,aAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAjD5B;AAoD4B;EACI,WAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,6DAAA;EACA,wCAAA;EACA,aAAA;EACA,mDAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;AAlDhC;AAoDgC;EACI,6DAAA;AAlDpC;;AA8DA;EACI;IACI,uBAAA;EA3DN;EA8DE;IACI,yBAAA;EA5DN;AACF","sourcesContent":[".setting_container {\n    width: 100%;\n    height: 100vh;\n    padding: 0 2rem;\n    position: absolute;\n    top: 0;\n    background-color: #151018;\n    z-index: 2;\n    overflow-x: hidden;\n    overflow-y: auto;\n\n    .setting_header {\n        width: 100%;\n        padding: 2rem 1.5rem .2rem 1.5rem;\n        display: flex;\n\n        .setting_logo {\n            width: 15%;\n            display: flex;\n            align-items: center;\n            position: relative;\n\n            img {\n                width: 30%;\n                margin-left: 30%;\n            }\n\n            .back {\n                position: absolute;\n                right: .4rem;\n                top: 50%;\n                transform: translateY(-50%);\n                width: 46.34px;\n                height: 46.34px;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: 1.4rem;\n                color: #FFFFFF;\n                background-color: #231B27;\n                border: 1px solid #231B27;\n                border-radius: .4rem;\n\n                &:hover {\n                    background-color: #2a202e;\n                    color: rgb(214, 65, 10);\n                }\n            }\n        }\n\n        .setting_search {\n            width: 70%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            .input {\n                width: 100%;\n                height: 46.34px;\n                padding: .48rem 1rem;\n                outline: none;\n                background-color: #231B27;\n                border-radius: .6rem;\n                border: 1px solid #231B27;\n                color: #898989;\n                font-size: 1.2rem;\n\n                &::placeholder {\n                    color: #898989;\n                }\n            }\n        }\n\n        .setting_avatar {\n            width: 15%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            position: relative;\n            user-select: none;\n\n            .avatar {\n                width: 3.313rem;\n                height: 3.313rem;\n                background-color: #bababa;\n                border-radius: 50%;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: 1.3rem;\n                font-weight: 700;\n                cursor: pointer;\n                transition: .1s linear;\n\n                &:hover {\n                    background-color: #e8e5e5;\n                    color: rgb(214, 65, 10);\n                    font-size: 1.5rem;\n                }\n            }\n\n            .sub_list {\n                width: 80%;\n                margin: 0 auto;\n                padding: .5rem .2rem;\n                background-color: #231B27;\n                position: absolute;\n                bottom: -3.5rem;\n                // bottom: 0;\n                border-radius: .6rem;\n                z-index: 10;\n\n                .item {\n                    display: block;\n                    // text-align: center;\n                    margin: .4rem 1rem;\n                    text-decoration: none;\n                    color: #FFFFFF;\n\n                    &:hover {\n                        color: rgb(214, 65, 10);\n                    }\n                }\n            }\n        }\n    }\n\n    .setting_content {\n        width: 70%;\n        margin: 0 auto;\n        padding: 0 1rem;\n\n        h2 {\n            color: #FFFFFF;\n            margin: 1rem 0;\n            font-size: 2rem;\n        }\n\n        .setting_settings {\n            width: 55rem;\n            min-height: 36rem;\n            background-color: #231B27;\n            padding: 1rem 2rem;\n            margin-bottom: 2rem;\n            border-radius: .8rem;\n            font-size: 80%;\n\n            .options {\n                display: flex;\n                font-size: 1rem;\n                font-weight: 500;\n                gap: 3rem;\n                margin-top: 1rem;\n\n                li {\n                    list-style: none;\n                    color: #e8e5e5;\n                    border-bottom: 1px solid #e8e5e5;\n                    cursor: pointer;\n                }\n            }\n\n            .setting_details {\n                &_content {\n                    width: 100%;\n                    padding: 1rem .5rem;\n                    margin-top: 2rem;\n\n                    .input_block {\n                        display: flex;\n                        flex-direction: column;\n                        gap: .5rem;\n                        margin: 1.5rem 0;\n\n                        label {\n                            font-weight: 400;\n                            font-size: 1rem;\n                            color: #FFFFFF;\n                        }\n\n                        .validate_all_doc{\n                            width: 12.9rem;\n                            background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);\n                            color: #FFFFFF;\n                            font-weight: 600;\n                            font-size: .9rem;\n                            display: flex;\n                            justify-content: space-around;\n                            align-items: center;\n                            padding: .6rem 1rem;\n                            outline: none;\n                            border: 1px solid transparent;\n                            border-radius: .3rem;\n                            cursor: pointer;\n                            transition: .2s linear;\n\n                            &:hover {\n                                background: linear-gradient(180deg, #D91D6F 50%, #92124A 100%);\n                                border: 1px solid #FFFFFF;\n                            }\n                        }\n\n                        .img {\n                            width: 12%;\n                            display: flex;\n                            justify-content: center;\n                            align-items: center;\n                        }\n\n                        .creating {\n                            display: flex;\n                            animation: detecting .8s linear infinite;\n                        }\n\n                        select {\n                            width: 60%;\n                            height: 3rem;\n                            outline: none;\n                            padding-left: .5rem;\n                            background-color: #231B27;\n                            border: .12rem solid #FFFFFF;\n                            border-radius: .3rem;\n                            color: #FFFFFF;\n                            font-weight: 600;\n                        }\n                    }\n\n                }\n\n                &_group {\n                    width: 100%;\n                    margin-top: 2rem;\n                    display: flex;\n                    // border: 1px solid red;\n\n                    .mumbers {\n                        width: 100%;\n                        position: relative;\n                        padding: 1.5rem .5rem;\n\n                        .mumber_avatar {\n                            display: flex;\n                            justify-content: center;\n                            align-items: center;\n                            text-transform: capitalize;\n                            font-size: 1.1rem;\n                            font-weight: 700;\n                            width: 3rem;\n                            height: 3rem;\n                            background-color: #bababa;\n                            border-radius: 50%;\n                            position: absolute;\n                            top: 0;\n                            user-select: none;\n                            border: 1px solid rgb(255, 255, 255);\n\n                            &:hover {\n                                background-color: #e8e5e5;\n                            }\n                        }\n                    }\n                }\n\n                &_police {\n                    width: 100%;\n                    padding: .5rem .5rem;\n                    margin-top: .5rem;\n                    display: flex;\n                    // border: 1px solid red;\n\n                    .police_left {\n                        width: 50%;\n                        display: flex;\n                        flex-direction: column;\n                        gap: .5rem;\n                        // border: 1px solid red;\n\n                        .police_block {\n                            display: flex;\n                            flex-direction: column;\n                            gap: .2rem;\n\n                            label {\n                                font-weight: 400;\n                                font-size: .8rem;\n                                color: #FFFFFF;\n                            }\n\n                            select,\n                            input {\n                                width: 80%;\n                                height: 2rem;\n                                outline: none;\n                                padding-left: .5rem;\n                                background-color: #231B27;\n                                border: .12rem solid #FFFFFF;\n                                border-radius: .3rem;\n                                color: #FFFFFF;\n                                font-weight: 600;\n                            }\n\n                            input[type=\"range\"] {\n                                width: 80%;\n                                height: 6px;\n                                margin: .4rem 0;\n                                background: #dddddd;\n                                border-radius: 5px;\n                                outline: none;\n                                -webkit-appearance: none;\n                                appearance: none;\n        \n                                &::-webkit-slider-thumb {\n                                    -webkit-appearance: none;\n                                    appearance: none;\n                                    width: 6px;\n                                    height: 20px;\n                                    background: #898989;\n                                    border-radius: 1rem;\n                                    cursor: pointer;\n                                  }\n                            }\n\n                            .show_hide_stroke {\n                                width: 80%;\n                                display: flex;\n                                align-items: center;\n                                font-size: 1.8rem;\n                                border: 1px solid red;\n                            }\n                        }\n\n                        .police_block_eye {\n                            display: flex;\n                            flex-direction: row;\n                            align-items: center;\n                            gap: .2rem;\n\n                            label {\n                                font-weight: 400;\n                                font-size: .8rem;\n                                color: #FFFFFF;\n                            }\n\n                            .show_hide_stroke {\n                                width: fit-content;\n                                display: flex;\n                                align-items: center;\n                                font-size: 1.8rem;\n                                // border: 1px solid red;\n                            }\n                        }\n                    }\n\n                    .police_right {\n                        width: 50%;\n                        height: 20rem;\n                        position: relative;\n                        // border: 1px solid green;\n\n                        svg {\n                            width: 30rem;\n                            background-color: #c5c5c5;\n                            // border: 1px solid red;\n                        }\n\n                        .valid_btn {\n                            display: flex;\n                            width: 100%;\n                            justify-content: flex-end;\n                            position: absolute;\n                            bottom: -10rem;\n                            // border: 1px solid red;\n\n                            button {\n                                width: 8rem;\n                                height: 2.5rem;\n                                font-size: 1rem;\n                                font-weight: 600;\n                                background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);\n                                color: #FFFFFFB2;\n                                outline: none;\n                                border: 1px solid #FFFFFF26;\n                                border-radius: .2rem;\n                                cursor: pointer;\n                                transition: .2s linear;\n\n                                &:hover {\n                                    background: linear-gradient(180deg, #D91D6F 100%, #92124A 0%);\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n\n        }\n    }\n}\n\n@keyframes detecting {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
